import Axios from "axios";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { API_URL } from "../../../../../../../../../../../config";
import { modalActions } from "../../../../../../../../../../../context/actions/modalActions";
import useStore from "../../../../../../../../../../../context/useStore";
import Loader from "../../../../../../../../../../common/Loader";

const LIBELLES = {
  client: ["client", "clients"],
  contrats: ["contrat", "contrats"],
  avenants: ["avenant", "avenants"],
  quittances: ["quittance", "quittances"],
};

const formatEntites = (entites = {}) =>
  Object.keys(LIBELLES)
    .filter((key) => entites[key] > 0)
    .map((key) => `${entites[key]} ${LIBELLES[key][entites[key] > 1 ? 1 : 0]}`)
    .join(", ");

const ResyncClientSummary = ({ companyId }) => {
  const [state, dispatch] = useStore();
  const mActions = modalActions(state, dispatch);
  const [summary, setSummary] = useState(null);

  const closeModal = () => {
    mActions.updateModal({
      isOpen: false,
      content: null,
      noClose: false,
      contentStyle: {},
    });
  };

  useEffect(() => {
    Axios.post(API_URL + `clients/${companyId}/resynchroniser`, null, {
      timeout: 60000,
    })
      .then((res) => {
        setSummary(res.data);
        mActions.updateModal({ noClose: false });
      })
      .catch((err) => {
        const status = err.response && err.response.status;
        if (err.code === "ECONNABORTED") {
          toast.error(
            "La synchronisation prend plus de temps que prévu, veuillez réessayer."
          );
        } else if (status === 409) {
          toast.error("Ce client n'est pas encore synchronisé avec graal.");
        } else if (status === 404) {
          toast.error("graal ne connaît pas ce client.");
        } else {
          toast.error("La synchronisation a échoué, veuillez réessayer.");
        }
        closeModal();
      });
  }, []);

  if (!summary) {
    return (
      <div className="d-flex flex-column align-items-center py-4">
        <Loader />
        <span className="mt-3">Synchronisation depuis Modulr en cours...</span>
      </div>
    );
  }

  const upsertes = formatEntites(summary.upsertes);
  const supprimes = formatEntites(summary.supprimes);

  return (
    <div>
      <h4>
        <i className="fa fa-check-circle text-success mr-2" />
        Synchronisation terminée
      </h4>
      {!upsertes && !supprimes ? (
        <p>Aucune modification : la fiche client est déjà à jour.</p>
      ) : (
        <>
          <ul className="list-group mb-3">
            {upsertes && (
              <li className="list-group-item d-flex align-items-baseline">
                <span className="badge badge-success badge-pill mr-2 flex-shrink-0">
                  Mis à jour
                </span>
                <span>{upsertes}</span>
              </li>
            )}
            {supprimes && (
              <li className="list-group-item d-flex align-items-baseline">
                <span className="badge badge-danger badge-pill mr-2 flex-shrink-0">
                  Supprimés
                </span>
                <span>{supprimes}</span>
              </li>
            )}
          </ul>
          <div className="alert alert-warning">
            <i className="fa fa-exclamation-triangle mr-2" />
            Les données affichées dans la liste ne sont plus à jour, relancez
            la recherche pour voir les changements.
          </div>
        </>
      )}
      <button className="btn btn-primary" onClick={closeModal}>
        Fermer
      </button>
    </div>
  );
};

export default ResyncClientSummary;
